export default {
  LOAD_TENANTS: 'Cargar Inquilinos',
  WELCOME: 'Bienvenido',
  ON: 'Encendido',
  OFF: 'Apagado',
}